import { useEffect, useState } from "react";
import moment from 'moment';
import { t } from "i18next";
import eventsIcon from "../../assets/images/events.svg";
import eventGreenIcon from "../../assets/images/event-green.svg";
import { Link, useNavigate } from "react-router-dom";
import { getEvents } from "../../services/event";
import { Event } from "../../interfaces/event";
import 'moment/locale/es';
import { LoadingSpinner } from "../general/loading-spinner";

export function EventsBlock() {
    const navigate = useNavigate();
    moment.locale('es');

    const [events, setEvents] = useState<any[]>([]);
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        getEvents()
            .then(response => {
                setEvents(response.data);
                setLoaded(true);
            })
            .catch(error => {
                alert(t('connection_expired'));
                localStorage.removeItem('token');
                navigate("/");
                console.log(error);
            });
    }, []);

    return (
        <div className="block block-events">
            <div className="block-inner">
                <h3 className="block-title">
                    <img src={ eventsIcon } alt={ t("Events")} />
                    { t("Events") }
                </h3>
                <div className="block-content">
                    { !loaded && 
                        <LoadingSpinner />
                    }
                    { loaded && events.length > 0 &&
                        events.map((c: Event) => {
                            return <div key={ 'event-' + c.id } className="event-tile">
                                    <div className="icon">
                                        <img src={ eventGreenIcon } />
                                    </div>
                                    <div className="title">
                                        <Link to={ '/events/' + c.id + '/view' }  title={ c.name }>
                                            { c.name }
                                        </Link>
                                    </div>
                                    <div className="date_start">
                                        { moment(c.date_start).format('D MMMM') }
                                    </div>
                                </div>
                        })
                    }
                    { loaded && events.length == 0 &&
                        <div className="message">
                            { t("There are no upcoming events.") }
                        </div>
                    }
                </div>
            </div>
        </div>
    );
}  
